import { render, staticRenderFns } from "./MediaPreview.vue?vue&type=template&id=389cc1a2&scoped=true&"
import script from "./MediaPreview.vue?vue&type=script&lang=js&"
export * from "./MediaPreview.vue?vue&type=script&lang=js&"
import style0 from "./MediaPreview.vue?vue&type=style&index=0&id=389cc1a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389cc1a2",
  null
  
)

export default component.exports